import { render, staticRenderFns } from "./NeedsTranslationInfo.vue?vue&type=template&id=648f74b8&scoped=true"
import script from "./NeedsTranslationInfo.vue?vue&type=script&lang=js"
export * from "./NeedsTranslationInfo.vue?vue&type=script&lang=js"
import style0 from "./NeedsTranslationInfo.vue?vue&type=style&index=0&id=648f74b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f74b8",
  null
  
)

export default component.exports